import * as R from 'ramda'
import he from 'he'
import { isEmptyOrNil } from 'libs/empty'

export const truncate = R.curry((limit, text) =>
  R.when(
    R.compose(R.gte(R.__, limit), R.length),
    R.compose(R.join(''), R.append('...'), R.take(limit)),
  )(text),
)

// defaultTextCount :: (String -> Int) -> Maybe String -> Int
export const defaultTextCount = R.ifElse(isEmptyOrNil, R.always(0))
// removeHTMLTags :: String -> String
export const removeHTMLTags = R.replace(/(<([^>]+)>)/gi, '')
// removeNewline :: String -> String
export const removeNewline = R.replace(/\r?\n|\r|\n|\u2028|\u2029/g, '')

// textToTextCount :: Maybe String -> Int
export const textToTextCount = R.compose(R.length, he.decode)

// htmlToTextCount :: Mabye String -> Int
export const htmlToTextCount = defaultTextCount(
  R.compose(textToTextCount, removeHTMLTags, removeNewline),
)

// htmlToPlainText :: Mabye String -> Maybe String
export const htmlToPlainText = R.unless(
  isEmptyOrNil,
  R.compose(he.decode, removeHTMLTags),
)

export const isStartWithEng = (str) => R.test(/^[A-Za-z]/g, str)

export const getAvatarPlaceHolder = (firstName, lastName) => {
  return R.compose(
    R.toUpper,
    R.join(''),
    R.pluck(0),
    R.append(lastName),
    R.append(firstName),
    R.defaultTo([]),
  )()
}

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const isValidEmail = (email) => {
  return email.trim().match(emailRegex) !== null
}
